import { GridCellProps } from '@progress/kendo-react-grid';
import { flatten } from 'lodash';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { getIcon } from 'src/utils/icons';

const InvoiceWarningCell = (props: GridCellProps) => {
  const { dataItem } = props;

  const errorMessages: string[] = useMemo(
    () => flatten(Object.values(dataItem?.errors || {})),
    [dataItem.errors]
  );

  const infos: string[] = useMemo(
    () => flatten(Object.values(dataItem?.informations || {})),
    [dataItem.informations]
  );

  return (
    <GridCellBase {...props} className={`overflow-visible-imp`} disableToolTip>
      <PopUp
        popupAlign={{ horizontal: 'left', vertical: 'bottom' }}
        anchorAlign={{ horizontal: 'right', vertical: 'center' }}
        className="max-h-[180px] "
        content={
          <div className="m-1 max-w-[350px]">
            <PopUpContentWrapper type="Error" contents={errorMessages} />
            <PopUpContentWrapper type="Information" contents={infos} />
          </div>
        }
      >
        <div className="flex justify-center items-center">{getIcon(errorMessages, [], infos)}</div>
      </PopUp>
    </GridCellBase>
  );
};

export default InvoiceWarningCell;
